module.exports = __webpack_public_path__ + "stockLibrary/simulator_image-a3a57f830f6a862ad00376ace9a88f55.png";